import styles from "./components.module.css"

const Footer = () => {
    return (
        <div className={styles.footer}>
          <h4>Designed by Henry Hartzler and Talha Hisham</h4>
        </div>
      );
}
 
export default Footer;